import { render, staticRenderFns } from "./VerticalNavMenuCustom.vue?vue&type=template&id=75cd8166"
import script from "./VerticalNavMenuCustom.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports